import { ExtendedAccount } from "@common/types/reports/types";
import {
    getArchiveBlockReason,
    getDeleteBlockReason,
    getMergeBlockReason,
} from "@components/accounting/chartOfAccounts/accountActionEligibility";
import { GetRowCapabilities } from "../editorCapabilities";

const NO_REASONS = {
    renameBlockReason: null,
    codeEditBlockReason: null,
    typeChangeBlockReason: null,
    archiveBlockReason: null,
    deleteBlockReason: null,
    mergeBlockReason: null,
    hasOpeningBalance: false,
    hasChartSeed: false,
    placeholder: null,
    role: null,
} as const;

export const makeWorkspaceRowCapabilities =
    ({
        accountsById,
    }: {
        accountsById: Map<string, ExtendedAccount>;
    }): GetRowCapabilities =>
    (account) => {
        const extended = accountsById.get(account.id);
        if (!extended) {
            return { ...NO_REASONS };
        }
        return {
            renameBlockReason: null,
            // A connected bank account is not a Kick default (financialAccountId
            // set) but still cannot change type.
            typeChangeBlockReason: !extended.isManuallyCreated
                ? "System accounts can't change type."
                : null,
            codeEditBlockReason: null,
            archiveBlockReason: getArchiveBlockReason(extended),
            deleteBlockReason: getDeleteBlockReason(extended),
            // Archived status from this session's draft, not the open-time seed.
            mergeBlockReason: getMergeBlockReason({
                ...extended,
                isDisabled: account.isDisabled,
            }),
            hasOpeningBalance: extended.hasOpeningBalance,
            hasChartSeed: true,
            // Row-level; a per-account producer never sees two constituents.
            placeholder: null,
            role: extended.role ?? null,
        };
    };
